import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: any): string {
    const numericValue = Number(value) / 100;
    return '$' + numericValue.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  }
}
